import { Flex, Typography } from "antd";
import { FormattedMessage } from "react-intl";

import "./NoAccessView.scss";

type Props = {
  intlMessageId: string;
};

const NoAccessView = ({ intlMessageId }: Props) => (
  <Flex justify="center" align="center" className="mt-5">
    <Typography.Text className="no-access-message">
      <FormattedMessage id={intlMessageId} />
    </Typography.Text>
  </Flex>
);

export default NoAccessView;
